<template>
  <div class="screen-index">
    <div class="activity-wraper" :class="{'filter-blur':signModal||overModal||Modal}">
      <div class="activity-title">
        <div class="back" @click="goToLoading">
          <span>{{ $t("screen.cancelScreen") }}</span>
        </div>
        <div class="title">
          {{activityDetial.title}}
          <div class="vote-pic" v-if="activityDetial.picture">
            <span class="iconfont icon-sizhengtupian" @click="voteLargePic"></span>
          </div>
        </div>
        <div
          class="over"
          @click="overActivity"
          v-if="(activityType==1||activityType == 3||activityType == 5||activityType == 6)&&activityDetial.complete!=1&&activityDetial.finish!=0&&activityDetial.status!=1"
        >{{ $t("screen.endActivity") }}</div>
      </div>
      <router-view
        ref="votePic"
        @pushDetial="getDetial"
        :activitymoadal="signModal||overModal||Modal"
        @openVotePic="voteLargePic"
      ></router-view>
      <div class="operation">
        <div v-if="activityType==6 && activityDetial.status!=1">
          <div
            class="score"
            v-for="(item,index) in curScoreType"
            :key="'score-action' + index"
            @click="showAddStuModal(index)"
          >
            <span class="iconfont activity-icon" :class="item.css"></span>
            <span class="text">{{item.text}}</span>
          </div>
        </div>
        <div
          class="score"
          @click="goScorePage(0)"
          v-if="activityType==6 && activityDetial.status==1"
        >
          <span class="iconfont icon-zaicidafen activity-icon"></span>
          <span class="text">{{ $t("screen.scoreAgain") }}</span>
        </div>
        <div class="stu-enter" @click="showSignModal" v-if="activityType!=6&&activityType!=7">
          <span class="iconfont icon-huodongerweima activity-icon"></span>
          <span class="text">{{ $t("screen.activityQrcode") }}</span>
        </div>
        <div class="sponsor-activity" v-if="activityType!=7">
          <div class="activity-label">
            <span class="iconfont icon-faqihuodong activity-icon">
            </span>
            <ul class="activity-box">
              <li @click="showModal(6)">
                <img src="../../common/img/act_grade.png" class="activity-item dafen" />
                <span class="text">{{ $t("screen.actGrade") }}</span>
              </li>
              <li @click="showModal(4)">
                <img src="../../common/img/act_diss.svg" class="activity-item taolun" />
                <span class="text">{{ $t("screen.actDiss") }}</span>
              </li>
              <li @click="showModal(3)">
                <img src="../../common/img/act_askandanswer@3x.svg" class="activity-item qiangda" />
                <span class="text">{{ $t("screen.actResp") }}</span>
              </li>
              <li @click="showModal(5)">
                <img src="../../common/img/pick.png" class="activity-item xuanren" />
                <span class="text">{{ $t("screen.actPick") }}</span>
              </li>
              <li @click="showModal(2)">
                <img src="../../common/img/act_vote.svg" class="activity-item toupiao" />
                <span class="text">{{ $t("screen.actVote") }}</span>
              </li>
              <li @click="showModal(1)">
                <img src="../../common/img/act_sign.svg" class="activity-item dianming" />
                <span class="text">{{ $t("screen.actSign") }}</span>
              </li>
            </ul>
          </div>
          <span class="text">{{ $t("screen.startActivity") }}</span>
        </div>
      </div>
    </div>
    <modal :type="type" :modal="Modal" :modalTitle="modalTitle" @closeModal="closeModal"></modal>
    <scoreModal
      :type="type"
      :isAddStudent="isAddStudent"
      :activityId="activityDetial.id"
      @closeModal="closeScoreModal"
      v-if="isShowScoreModal"
      @pushDetial="getDetial"
    ></scoreModal>
    <div class="sign-modal" v-show="signModal" @click="closeSignModal">
      <div class="modal-title">{{ $t("system.scanCode") }}</div>
      <div class="erweima">
        <canvas id="activity_canvas"></canvas>
        <div class="text">{{ $t("screen.scanTip") }}</div>
        <div class="close" @click="closeSignModal">
          <span class="iconfont icon-guanbi"></span>
        </div>
      </div>
    </div>
    <!-- <div class="bg-img" v-if="signModal">
    </div>-->
    <div class="over-modal" v-if="overModal">
      <div class="over-wraper">
        <div class="over-title">{{ $t("system.remind") }}</div>
        <div class="text">{{overMsg}}</div>
        <div class="operation">
          <button class="sure" @click="overActivitySure">{{ $t("system.confirm") }}</button>
          <button class="cancel" @click="overActivityCancel">{{ $t("system.cancel") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import modal from "@/components/modal/modal/";
import scoreModal from "@/components/scoreModal/scoreModal";
import EventHandler from "../../common/js/EventHandler";
export default {
  name: "screenIndex",
  data() {
    return {
      type: 0,
      Modal: false,
      activity: [
        this.$t("screen.actSign"),
        this.$t("screen.actVote"),
        this.$t("screen.actResp"),
        this.$t("screen.actDiss"),
        this.$t("screen.actPick"),
        this.$t("screen.actGrade")
      ],
      modalTitle: "",
      signModal: false,
      overMsg: "",
      overModal: false,
      activityDetial: [],
      activityType: 1,
      isShowScoreModal: false,
      isAddStudent: false
    };
  },
  methods: {
    showModal: function(type) {
      this.type = type;
      this.Modal = true;
      this.modalTitle = this.common.getDate() + this.activity[this.type - 1];
    },
    closeModal: function() {
      this.Modal = false;
    },
    goToLoading: function() {
      this.overActivityScreen();
    },
    showSignModal: function() {
      this.useqrcode();
    },
    //生成活动二维码
    useqrcode() {
      var that = this;
      var a = that.type + 2;
      var c = that.common.getCookie("activityId");
      var d = that.common.getCookie("ocId");
      var e = that.common.getCookie("classScoreType");
      that.QueryDetail = that.pathURL + "/r/?a=" + a + "&c=" + c + "&d=" + d;
      if (a == 8) {
        that.QueryDetail =
          that.pathURL + "/r/?a=" + a + "&c=" + c + "&d=" + d + "&e=" + e;
      }
      console.log(that.QueryDetail);
      var canvas = document.getElementById("activity_canvas");
      QRCode.toCanvas(
        canvas,
        that.QueryDetail,
        { width: 558, height: 558 },
        function(error) {
          if (error) console.error(error);
          console.log("success!");
          that.signModal = true;
        }
      );
    },
    closeSignModal: function() {
      this.signModal = false;
    },
    voteLargePic: function() {
      this.$refs.votePic.largePic();
    },
    overActivity: function() {
      if (this.$route.name == "responder") {
        var isNoScore = false;
        for (
          var i = 0;
          this.activityDetial.students &&
          i < this.activityDetial.students.length;
          i++
        ) {
          if (this.activityDetial.students[i].score == 0) {
            isNoScore = true;
            break;
          }
        }
        if (isNoScore) {
          this.overMsg = this.$t("screen.tip1");
        }
      }
      this.overModal = true;
    },
    //结束点名
    overSign: function() {
      var that = this;
      var userId = Number(that.common.getCookie("userId"));
      var activityId = Number(that.common.getCookie("activityId"));
      that.$http
        .post(that.baseURL1 + "/newAttendance/finishAttendance", {
          attanceID: activityId,
          classID: -1,
          userID: userId
        })
        .then(res => {
          var data = res.data;
          that.overModal = false;
          console.log(data);
        });
    },
    //结束抢答
    overResponder: function() {
      var that = this;
      var userId = Number(that.common.getCookie("userId"));
      var activityId = Number(that.common.getCookie("activityId"));
      that.$http
        .post(that.baseURL1 + "/interlocution/changeComplete", {
          interlocutionId: activityId,
          complete: 1
        })
        .then(res => {
          var data = res.data;
          that.overModal = false;
          console.log(data);
        });
    },
    overPick() {
      let that = this;
      var activityId = Number(that.common.getCookie("activityId"));
      that.$http
        .post(that.baseURL1 + "/selectperson/endActivity?id=" + activityId)
        .then(res => {
          that.overModal = false;
          EventHandler.toggleEvent("overPick");
        });
    },
    //结束活动投屏
    overActivityScreen: function() {
      var that = this;
      var userId = that.common.getCookie("userId");
      var activityId = that.common.getCookie("activityId");
      that.$http
        .get(
          that.baseURL +
            "/appscreen/endActivity?type=" +
            that.type +
            "&userId=" +
            userId +
            "&activityId=" +
            activityId +
            "&sender=pc"
        )
        .then(res => {
          that.$router.replace("/loadingIn");
        });
    },
    overActivitySure: function() {
      if (this.type == 1) {
        this.overSign();
      }
      if (this.type == 3) {
        this.overResponder();
      }
      if (this.type == 5) {
        this.overPick();
      }
      if (this.type == 6) {
        this.goScorePage(1);
      }
    },
    overActivityCancel: function() {
      this.overModal = false;
    },
    showAddStuModal: function(index) {
      this.isAddStudent = index == 0;
      this.isShowScoreModal = true;
    },
    closeScoreModal: function() {
      this.isShowScoreModal = false;
    },
    goScorePage: function(status) {
      let activityId = this.common.getCookie("activityId");
      this.$http
        .post(
          `${this.baseURL1}/classscore/updateClassScoreStatus?id=${activityId}&status=${status}`
        )
        .then(res => {
          if (this.$route.name == "score") {
            window.location.reload();
          } else {
            this.$router.replace(`/screenIndex/score`);
          }
        });
    },
    getDetial: function(data) {
      this.activityDetial = data;
    },
    votePicOperation: function(param) {
      if (param == 1) {
        this.voteLargePic();
      }
    },
    checkActivityType: function() {
      if (this.$route.name == "signIn" || this.$route.name == "signDetail") {
        this.type = 1;
        this.activityType = 1;
        this.overMsg = this.$t("screen.tip2") + this.$t("screen.actSign") + "?";
      }
      if (this.$route.name == "vote") {
        this.type = 2;
        this.activityType = 2;
        this.overMsg = this.$t("screen.tip2") + this.$t("screen.actVote") + "?";
      }
      if (this.$route.name == "responder") {
        this.type = 3;
        this.activityType = 3;
        this.overMsg = this.$t("screen.tip2") + this.$t("screen.actResp") + "?";
      }
      if (this.$route.name == "discuss") {
        this.type = 4;
        this.activityType = 4;
        this.overMsg = this.$t("screen.tip2") + this.$t("screen.actDiss") + "?";
      }
      if (this.$route.name == "pick") {
        this.type = 5;
        this.activityType = 5;
        this.overMsg = this.$t("screen.tip2") + this.$t("screen.actPick") + "?";
      }
      if (this.$route.name == "score" || this.$route.name == "scoreDetail") {
        this.type = 6;
        this.activityType = 6;
        this.overMsg = this.$t("screen.tip3") + "?";
      }
      if (this.$route.name == "resource") {
        this.type = 7;
        this.activityType = 7;
        this.overMsg = "";
      }
    }
  },
  created: function() {
    var that = this;
  },
  mounted: function() {
    this.checkActivityType();
  },
  computed: {
    curScoreType() {
      let types = [];
      if (this.activityType == 6) {
        switch (this.activityDetial.type) {
          case 1:
            types = [
              {
                css: "icon-suijitianjia",
                text: this.$t("screen.randomAdd")
              },
              {
                css: "icon-zhidingtianjia",
                text: this.$t("screen.selectAdd")
              }
            ];
            break;
          case 2:
            types = [
              {
                css: "icon-tianjiaxiaozu",
                text: this.$t("screen.addGroup")
              }
            ];
            break;
          case 3:
            types = [
              {
                css: "icon-tianjiaxiaozu",
                text: this.$t("screen.addObject")
              }
            ];
            break;
          default:
            break;
        }
      }
      return types;
    }
  },
  watch: {
    $route(to, from) {
      this.checkActivityType();
    }
  },
  components: { modal, scoreModal }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "screenIndex.scss";
</style>



// WEBPACK FOOTER //
// src/components/screenIndex/screenIndex.vue